import { motion } from "framer-motion";
import NavigationColored from './../components/NavigationColored';
import serviceImage from './../../assets/images/services/private-cabins.jpg';

const pageVariants = {
  initial: { scale: 0.9, opacity: 0 },
  in: { scale: 1, opacity: 1 },
  out: { scale: 0.9, opacity: 0 }
};

const pageTransition = {
  type: "tween",
  ease: "easeInOut",
  duration: 0.5,
};

const PrivateCabins = () => {
  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <NavigationColored />
      <div style={{ marginTop: '4em' }}></div>
      <section className="service">
        <div className="container">
          <div className="section-title" style={{ marginBottom: "50px" }}>
            <h1>Private Cabins</h1>
            <p>“Your Own Office. Privacy, Focus, and Security in One Space.”</p>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <p align="justify">Private cabins offer secure, dedicated workspaces with privacy, ideal for focused work or teams. These enclosed office spaces are designed to give professionals and small teams the peace and quiet they need to concentrate, collaborate, and perform at their best. Each cabin is furnished with ergonomic chairs, spacious desks, lockable storage, and individual climate control (if available), ensuring a comfortable and secure working environment. With access to common amenities like meeting rooms, high-speed internet, pantry areas, and support staff, private cabins combine the benefits of independence with the conveniences of a managed office. They are perfect for startups, executives, consultants, or remote teams seeking a professional setting with zero distractions.</p>
            </div>
            <div className="col-lg-6 col-md-6 sub-services">
              {/* <ul>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Save time & reduce overheads</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Scale up or down easily</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Improve team productivity</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Impress clients with professional space</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Plug-and-play setup</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />No maintenance worries</li>
                <li><i className="fa fa-hand-o-right" aria-hidden="true" />Nearby landmarks, parking, metro/train stations</li>
              </ul> */}
              <img className="service-image" src={serviceImage} alt="service Image"/>
            </div>
          </div>
        </div>
      </section>
    </motion.div>
  )
}

export default PrivateCabins
